// src/constants/menuItems.js

export const mainMenuItems = [
  { label: 'Customers', path: '/customers' },
  { label: 'Pets', path: '/pets' },
  { label: 'Services', path: '/services' },
];

export const adminMenuItems = [
  { label: 'Groomers', path: '/groomers' },
  { label: 'Users', path: '/users' },
  { label: 'Reports', path: '/reports' },
];

export const mainAddMenuItems = [
  { label: 'Customer', path: '/add-customer' },
  { label: 'Pet', path: '/add-pet' },
  { label: 'Service', path: '/add-service' },
];

export const adminAddMenuItems = [
  { label: 'Groomer', path: '/add-groomer' },
  { label: 'User', path: '/add-user' },
];

export const mainSearchMenuItems = [
  { label: 'Customers', value: 'customers' },
  { label: 'Pets', value: 'pets' },
  { label: 'Services', value: 'services' },
];

export const adminSearchMenuItems = [
  { label: 'Groomers', value: 'groomers' },
  { label: 'Users', value: 'users' },
];